import { css } from "@emotion/react";
import { kitText } from "../../styles";

export const styles = {
  base: css`
    interpolate-size: allow-keywords;

    &[open] > summary .kit-details-summary-toggle-icon {
      transform: rotate(-180deg);
    }

    &::details-content {
      height: 0;
      overflow: clip;
      transition:
        height 250ms ease-in-out,
        content-visibility 250ms ease-in-out allow-discrete;
    }

    &[open]::details-content {
      height: auto;
    }
  `,
  summary: css`
    display: flex;
    align-items: center;
    gap: var(--spacing-4);
    cursor: pointer;
    justify-content: space-between;

    &::-webkit-details-marker,
    &::marker {
      display: none;
      content: "";
    }
  `,
  toggleIcon: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--spacing-24);
    min-width: var(--spacing-24);
    height: var(--spacing-24);
    transition: transform 0.2s ease-in-out;
    --icon-fill-color: var(--color-secondary);
  `,
  actions: css`
    display: flex;
    align-items: center;
    gap: var(--spacing-8);
    margin: auto 0 auto auto;
    padding-left: var(--spacing-8);
  `,
  variant: {
    default: css`
      > summary {
        background: var(--color-background-low-contrast);
        border-radius: var(--border-radii-lg);
        padding: var(--spacing-8) var(--spacing-12);
        ${kitText.style.bold}
        width: 100%;
        margin-bottom: 0;
        transition: margin-bottom 250ms ease-in-out;
      }
      &[open] > summary {
        margin-bottom: var(--spacing-8);
      }
    `,
    inline: css`
      > summary {
        display: inline-flex;
        gap: var(--spacing-4);
      }
    `
  }
};
